import { useEffect, useState } from "react";

import type { MutableRefObject } from "react";
import type { BinaryFiles } from "@excalidraw/excalidraw/types";

import { getElementsStorageSize } from "../data/localStorage";

const INTERVAL_MS = 2000;
const MOBILE_BREAKPOINT = 768;

const formatMB = (bytes: number): string => {
  const mb = bytes / (1024 * 1024);
  if (mb < 0.1) return "< 0.1 MB";
  return `${mb.toFixed(1)} MB`;
};

export const StorageIndicator = ({
  filesRef,
}: {
  filesRef: MutableRefObject<BinaryFiles>;
}) => {
  const [label, setLabel] = useState("");
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    const onResize = () =>
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const compute = () => {
      const elementsSize = getElementsStorageSize();
      const filesSize = Object.values(filesRef.current).reduce(
        (sum, f) => sum + (f?.dataURL?.length ?? 0),
        0,
      );
      setLabel(formatMB(elementsSize + filesSize));
    };
    compute();
    const id = setInterval(compute, INTERVAL_MS);
    return () => clearInterval(id);
  }, [filesRef]);

  if (!label || isMobile) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 8,
        right: 8,
        fontSize: 11,
        color: "#bbb",
        fontFamily:
          "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
        pointerEvents: "none",
        userSelect: "none",
        zIndex: 9999,
      }}
    >
      {`disk usage: ${label}`}
    </div>
  );
};
